import styled from 'styled-components'

export default styled.div`
  background: #fff0e2;
  height: 100%;
  display: flex;
  flex-direction: column;
`
